export default [
  [`Размер`, `56`, `62`, `68`, `74`, `80`, `86`],
  [`Длина тела, см`, `38`, `40`, `42`, `44`, `46`, `48`],
  [`Длина рукава, см`, `23`, `24`, `25`, `26`, `27`, `28`],
  [`Ширина груди, см`, `22.5`, `23`, `23.5`, `24`, `24.5`, `25`],
  [`Рост, см`, `56-62`, `62-68`, `68-74`, `74-80`, `80-86`, `86-92`],
  [`Возраст`, `0 мес`, `3 мес.`, `6 мес.`, `9 мес.`, `12 мес.`, `18 мес.`]
];
